// Design tokens shared across the mobile SVG audio scenes.

export const EASE = [0.16, 1, 0.3, 1]

// One accent hue per chapter, echoing the desktop scenes' cyan/blue palette.
export const CHAPTER_ACCENTS = [
  '#8ff2ff', // 0  Birth of Sound
  '#22ddff', // 1  Waveforms
  '#5fb8ff', // 2  Fourier
  '#ff9a5f', // 3  Mel-Spectrogram
  '#7dff9a', // 4  VAD & Noise
  '#c586ff', // 5  Speech Recognition
  '#ff6ec7', // 6  Audio Embeddings
  '#ffd166', // 7  Voice Cloning
  '#5fe0c0', // 8  Text To Speech
  '#ff8a8a', // 9  Emotion & Prosody
  '#6ec2ff', // 10 Realtime Agents
  '#a8ffb0', // 11 Audio AI Universe
  '#8ff2ff', // 12 Learning Roadmap
]

export const accentFor = (i) => CHAPTER_ACCENTS[i] ?? CHAPTER_ACCENTS[0]
